import $ from 'jquery';
import config from '../../config/config';
import {initFlyin} from './flyin';
import {createAccountSlider} from './components/accountslider';

const mobileMQ = window.matchMedia(`(max-width: ${config.BREAKPOINTS.TABLET_MAX}px)`);
const childSelector = '.account-card';
const container = document.querySelector('.account-overview-container');
let configuration = {};
// select document scope
const range = document.createRange();
const unusedComponents = {};
let view;

if (container !== null) {
    configuration = JSON.parse(container.dataset.configuration);
}

/**
 * Sorts two elements based on their
 * position data attribute
 *
 * @param {HTMLElement} a - first element
 * @param {HTMLElement} b - second element
 * @returns {number} sort order
 */
const comparePosition = (a, b) => {
    const aPos = a.dataset.position;
    const bPos = b.dataset.position;

    if (aPos > bPos) {
        return 1;
    }

    if (aPos < bPos) {
        return -1;
    }

    // aPos === bPos
    return 0;
};

/**
 * Displays the page components for the new view
 * and sorts them based on the given position
 * in configuration of each component
 *
 * @param {Array} componentsArray - array with components to display and sort
 * @param {string} newView - the new layout view: desktop or mobile
 */
const displayComponents = (componentsArray, newView) => {
    // update component position
    for (let i = 0, len = componentsArray.length; i < len; i++) {
        const {type} = componentsArray[i].dataset;
        componentsArray[i].dataset.position = configuration[newView][type].position;
    }

    // sort elements
    componentsArray.sort((a, b) => comparePosition(a, b)).forEach(item => container.appendChild(item));
};

/**
 * Re-paints the layout with different components on screen size
 * changes if necessary
 */
const rehydrateDom = () => {
    const newView = mobileMQ.matches ? 'mobile' : 'desktop';
    let useAsync = false;
    if (newView !== view && configuration[newView]) {
        const children = container.querySelectorAll(childSelector);
        const componentsArray = [];

        // loop children and see if there are unused for the new view
        for (let i = 0, len = children.length; i < len; i++) {
            const element = children[i];
            const {type} = element.dataset;
            if (!(type in configuration[newView])) {
                unusedComponents[type] = element;
                container.removeChild(element);
            } else {
                componentsArray.push(element);
            }
        }

        // check if we need to request new component
        for (const card in configuration[newView]) {
            if (configuration[view] && !(card in configuration[view])) {
                if (card in unusedComponents) {
                    componentsArray.push(unusedComponents[card]);
                    delete unusedComponents[card];
                } else {
                    useAsync = true;
                    $.ajax({
                        type: 'GET',
                        dataType: 'html',
                        url: container.dataset.componentUrl,
                        data: {
                            card,
                            view: newView
                        },
                        /**
                         * Asynchronous request success state
                         *
                         * @param {Object} response response data
                         */
                        success: response => {
                            const documentFragment = range.createContextualFragment(response);
                            const tempContainer = document.createElement('div');
                            tempContainer.appendChild(documentFragment);
                            componentsArray.push(tempContainer.querySelector(childSelector));
                            displayComponents(componentsArray, newView);
                        }
                    });
                }
            }
        }

        if (!useAsync) {
            displayComponents(componentsArray, newView);
        }
        view = newView;
    }
};

/**
 * Initializes the newsletter benefits slider component
 */
const initBenefitsSlider = () => {
    $('.benefits-card').show();
    const $benefitElements = $('.benefits-card .my-account-overview-benefits ul').not('.slick-initialized');
    createAccountSlider($benefitElements);
};

/**
 * Initializes the stamp rally slider component
 */
const initStampRallySlider = () => {
    const $stampRallyElements = $('.stamp-rally-card .stamp-rally-more .slider-tiles').not('.slick-initialized');
    createAccountSlider($stampRallyElements, {
        autoplay: false,
        dots: false,
        responsive: [
            {
                breakpoint: config.BREAKPOINTS.TABLET_MAX,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: config.BREAKPOINTS.DESKTOP_MAX,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
};

/**
 * Initializes page event listeners
 */
const initializeEvents = () => {
    $('.account-overview').on('click', '.flyin-link', () => {
        initFlyin();
    });

    $('.account-overview').on('click', '.js-copy_coupon', function () {
        navigator.clipboard.writeText($(this).data('code'));
    });

    $('.account-overview').on('click', '.js-toggle', function () {
        const isOpen = $(this).attr('aria-expanded') === 'true';

        $(this).toggleClass('expanded').attr('aria-expanded', !isOpen);
    });
};

/**
 * Initializes the wishlist slider component
 */
const initWishlistSlider = () => {
    const $wishlistItems = $('.wishlist-card .wishlist-items').not('.slick-initialized');
    createAccountSlider($wishlistItems, {
        autoplay: false,
        dots: false,
        responsive: [
            {
                breakpoint: config.BREAKPOINTS.TABLET_MAX,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: config.BREAKPOINTS.DESKTOP_MAX,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
};

/**
 * Initializes the wishlist slider component
 */
const initCouponsSlider = () => {
    const $couponItems = $('.coupon-cards .coupon-items').not('.slick-initialized');
    createAccountSlider($couponItems, {
        autoplay: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '24px',
        responsive: [
            {
                breakpoint: config.BREAKPOINTS.TABLET_MAX,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: config.BREAKPOINTS.DESKTOP_MAX,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
};

/**
 * Hides the `personal updates` section if no cards are rendered.
 */
const hidePersonalUpdatesIfEmpty = () => {
    const personalUpdates = container.querySelector('.account-card.personal-updates');
    if (personalUpdates) {
        const contentSlot = personalUpdates.querySelectorAll('[class*="account-overview-personal-updates-"]');
        if (contentSlot.length === 0) {
            personalUpdates.style.display = 'none';
        }
    }
};

/**
 * Initializes the Benexy Barcode component
 */
export const initBenexyBarcode = () => {
    if (typeof JsBarcode === 'function') {
        /* eslint-disable no-undef */
        JsBarcode('.benexy_barcode').init();
    }
};

/**
 * Renders the various My Account Overview components asynchronously
 */
const renderComponents = () => {
    view = mobileMQ.matches ? 'mobile' : 'desktop';
    $.ajax({
        type: 'GET',
        dataType: 'html',
        url: container.dataset.componentsUrl,
        data: {
            view
        },
        /**
         * Asynchronous request success state
         *
         * @param {Object} response response data
         */
        success: response => {
            const documentFragment = range.createContextualFragment(response);
            container.appendChild(documentFragment);
            initBenefitsSlider();
            initWishlistSlider();
            initCouponsSlider();
            initStampRallySlider();
            initBenexyBarcode();
            hidePersonalUpdatesIfEmpty();
        }
    });
};

/* eslint-disable import/prefer-default-export */
/**
 * Initializes the My Account Overview page components and events.
 */
export const init = () => {
    initializeEvents();
    range.selectNode(document.getElementsByTagName('div').item(0));
    renderComponents();
    mobileMQ.addListener(rehydrateDom);
    mobileMQ.addListener(initBenefitsSlider);
    mobileMQ.addListener(initWishlistSlider);
    mobileMQ.addListener(initCouponsSlider);
    initBenexyBarcode();
};
